/**
 * Parses a decimal input string to number, accepting both dot and comma as decimal separator.
 * Returns undefined for empty/null/undefined values.
 */
export const parseDecimalInput = (value: string | number | null | undefined): number | undefined => {
  if (value === undefined || value === null || value === '') return undefined;
  const normalized = typeof value === 'string' ? value.replace(',', '.') : value;
  const parsed = Number(normalized);
  return Number.isNaN(parsed) ? undefined : parsed;
};
